import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

// Captures ?ref=CODE from any Pula link, records a fair click, and attributes the
// signed-in member to that ambassador (once). No cost to buyers, ever.
export default function RefCapture() {
  const { user } = useAuth();

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref");
      if (ref) {
        localStorage.setItem("pula_ref", ref);
        let vid = localStorage.getItem("pula_visitor");
        if (!vid) { vid = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("pula_visitor", vid); }
        api.post("/ambassador/track", { ref_code: ref, type: "click", path: window.location.pathname, visitor_id: vid }).catch(() => {});
      }
      const invite = params.get("invite");
      if (invite) localStorage.setItem("pula_invite", invite);
    } catch {}
  }, []);

  useEffect(() => {
    if (!user) return;
    const ref = localStorage.getItem("pula_ref");
    if (ref && !localStorage.getItem("pula_ref_done")) {
      api.post("/ambassador/attribute", { ref_code: ref }).then(() => localStorage.setItem("pula_ref_done", "1")).catch(() => {});
    }
    const invite = localStorage.getItem("pula_invite");
    if (invite) {
      api.post("/invite/claim", { ref: invite }).catch(() => {}).finally(() => localStorage.removeItem("pula_invite"));
    }
  }, [user]);

  return null;
}
